// extracted by mini-css-extract-plugin
export default {"pill":"_3RZRCwm"};